"use strict";

import Vue from 'vue';
import axios from "axios";
import qs from "qs";
import { Notice } from "iview";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  timeout: 60 * 1000, // Timeout
  withCredentials: false, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    if (config.method === "post") {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    if (response.data.code === 200) {
      return response.data;
    }else{
        Notice.error({
            title: 'Error',
            render: h => {
                return h('span', [
                    response.data.msg,
                ])
            }
        });
      return response.data;
    }
  },
  function(error) {
    // Do something with response error
      Notice.error({
          title: 'Error',
          render: h => {
              return h('span', [
                  "服务端异常"
              ])
          }
      });
    return Promise.reject(error);
  }
);

export default _axios;
